<section class="sana-auth register-page">
  <div class="register-form">
    <img
      src="/img/logo-without-slogan.png"
      alt="sanactivo"
      class="logo"
    />

    @if (isRegistered()) {
      <div class="done-state">
        <div class="done-icon">✓</div>
        <h2 class="done-title">Konto erstellt</h2>
        <p class="done-text">
          Wir haben dir eine Willkommens-E-Mail geschickt. Du kannst dich jetzt anmelden und deinen ersten Therapieplan erstellen.
        </p>
        <button
          type="button"
          class="btn btn-primary btn-inline"
          (click)="routeToLogin()">
          Zur Anmeldung
        </button>
      </div>
    } @else {
      <h2 class="title">Registrieren</h2>
      <p class="subtitle">Starte deine 4-wöchige Probemitgliedschaft.<br>Keine Kreditkarte erforderlich, keine automatische Verlängerung.</p>

      <div class="stepper" aria-label="Fortschritt der Registrierung">
        @for (step of steps; track step; let i = $index) {
          @if (i > 0) {
            <div
              class="stepper-connector"
              [class.reached]="step <= formStep()"></div>
          }
          <div
            class="stepper-step"
            [class.active]="step === formStep()"
            [class.done]="step < formStep()">
            <div class="stepper-circle">{{ step < formStep() ? '✓' : i + 1 }}</div>
            <div class="stepper-label">{{ stepLabels[i] }}</div>
          </div>
        }
      </div>

      <form
        autocomplete="on"
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()">

        @switch (formStep()) {
          @case (RegisterStepEnum.Personal) {
            <div class="step">
              <div class="field-grid">
                <label class="field">
                  <span class="field-label">Vorname <span class="required">*</span></span>
                  <input
                    class="input"
                    id="firstName"
                    name="firstName"
                    type="text"
                    autocomplete="given-name"
                    autofocus
                    maxlength="255"
                    [class.is-invalid]="registerForm.controls.firstName.invalid && registerForm.controls.firstName.touched"
                    [formControl]="registerForm.controls.firstName" />

                  @if (registerForm.controls.firstName.hasError('required') && registerForm.controls.firstName.touched) {
                    <span class="field-error">Bitte gib deinen Vornamen ein.</span>
                  }
                </label>

                <label class="field">
                  <span class="field-label">Nachname <span class="required">*</span></span>
                  <input
                    class="input"
                    id="lastName"
                    name="lastName"
                    type="text"
                    autocomplete="family-name"
                    maxlength="255"
                    [class.is-invalid]="registerForm.controls.lastName.invalid && registerForm.controls.lastName.touched"
                    [formControl]="registerForm.controls.lastName" />

                  @if (registerForm.controls.lastName.hasError('required') && registerForm.controls.lastName.touched) {
                    <span class="field-error">Bitte gib deinen Nachnamen ein.</span>
                  }
                </label>

                <label class="field">
                  <span class="field-label">E-Mail-Adresse <span class="required">*</span></span>
                  <input
                    class="input"
                    id="email"
                    name="email"
                    type="email"
                    autocomplete="email"
                    maxlength="255"
                    [class.is-invalid]="registerForm.controls.email.invalid && registerForm.controls.email.touched"
                    [formControl]="registerForm.controls.email" />

                  @if (registerForm.controls.email.hasError('required') && registerForm.controls.email.touched) {
                    <span class="field-error">Bitte gib deine E-Mail-Adresse ein.</span>
                  } @else if (registerForm.controls.email.hasError('email') && registerForm.controls.email.touched) {
                    <span class="field-error">Bitte gib eine gültige E-Mail-Adresse ein.</span>
                  }
                </label>

                <label class="field">
                  <span class="field-label">Name der Praxis / des Instituts <span class="required">*</span></span>
                  <input
                    class="input"
                    id="instituteName"
                    name="instituteName"
                    type="text"
                    autocomplete="organization"
                    maxlength="255"
                    [class.is-invalid]="registerForm.controls.instituteName.invalid && registerForm.controls.instituteName.touched"
                    [formControl]="registerForm.controls.instituteName" />

                  @if (registerForm.controls.instituteName.hasError('required') && registerForm.controls.instituteName.touched) {
                    <span class="field-error">Bitte gib den Namen deiner Praxis bzw. deines Instituts ein.</span>
                  }
                </label>
              </div>

              <div class="actions">
                <button type="submit" class="btn btn-primary">Weiter</button>
              </div>
            </div>
          }

          @case (RegisterStepEnum.Practice) {
            <div class="step">
              <div class="field-grid">
                <label class="field">
                  <span class="field-label">Titel (vorangestellt)</span>
                  <input
                    class="input"
                    id="titlePrefix"
                    name="titlePrefix"
                    type="text"
                    autofocus
                    maxlength="255"
                    [formControl]="registerForm.controls.titlePrefix" />
                </label>

                <label class="field">
                  <span class="field-label">Titel (nachgestellt)</span>
                  <input
                    class="input"
                    id="titleSuffix"
                    name="titleSuffix"
                    type="text"
                    maxlength="255"
                    [formControl]="registerForm.controls.titleSuffix" />
                </label>

                <label class="field">
                  <span class="field-label">Fachgebiet</span>
                  <input
                    class="input"
                    id="fieldOfSpecialisation"
                    name="fieldOfSpecialisation"
                    type="text"
                    maxlength="255"
                    [formControl]="registerForm.controls.fieldOfSpecialisation" />
                </label>

                <label class="field">
                  <span class="field-label">Telefonnummer</span>
                  <input
                    class="input"
                    id="phoneNumber"
                    name="phoneNumber"
                    type="tel"
                    autocomplete="tel"
                    maxlength="255"
                    [formControl]="registerForm.controls.phoneNumber" />
                </label>
              </div>

              <div class="section-title">Adresse</div>

              <div class="field-grid">
                <label class="field">
                  <span class="field-label">Straße</span>
                  <input
                    class="input"
                    id="street"
                    name="street"
                    type="text"
                    maxlength="255"
                    [formControl]="registerForm.controls.address.controls.street" />
                </label>

                <label class="field">
                  <span class="field-label">Hausnummer</span>
                  <input
                    class="input"
                    id="houseNumber"
                    name="houseNumber"
                    type="text"
                    maxlength="255"
                    [formControl]="registerForm.controls.address.controls.houseNumber" />
                </label>

                <label class="field">
                  <span class="field-label">PLZ</span>
                  <input
                    class="input"
                    id="zipCode"
                    name="zipCode"
                    type="text"
                    autocomplete="postal-code"
                    maxlength="255"
                    [formControl]="registerForm.controls.address.controls.zipCode" />
                </label>

                <label class="field">
                  <span class="field-label">Ort</span>
                  <input
                    class="input"
                    id="city"
                    name="city"
                    type="text"
                    maxlength="255"
                    [formControl]="registerForm.controls.address.controls.city" />
                </label>

                <label class="field">
                  <span class="field-label">Land</span>
                  <select
                    class="input"
                    id="country"
                    name="country"
                    [formControl]="registerForm.controls.address.controls.country">
                    <option [ngValue]="null">Bitte wählen</option>
                    @for (country of countryOptions; track country) {
                      <option [ngValue]="country">{{ getCountryTranslation(country) }}</option>
                    }
                  </select>
                </label>
              </div>

              @if (registerForm.controls.address.hasError('addressIncomplete') && registerForm.controls.address.touched) {
                <div class="form-error">
                  Bitte fülle alle Adressfelder aus oder lass die Adresse vollständig leer.
                </div>
              }

              <div class="actions">
                <button type="button" class="btn btn-secondary" (click)="previousStep()">Zurück</button>
                <button type="submit" class="btn btn-primary">Weiter</button>
              </div>
            </div>
          }

          @case (RegisterStepEnum.Password) {
            <div class="step">
              <div class="field-grid">
                <label class="field">
                  <span class="field-label">Passwort <span class="required">*</span></span>
                  <div class="password-wrapper">
                    <input
                      class="input"
                      id="password"
                      name="password"
                      autocomplete="new-password"
                      autofocus
                      maxlength="255"
                      [type]="showPassword() ? 'text' : 'password'"
                      [class.is-invalid]="registerForm.controls.password.invalid && registerForm.controls.password.touched"
                      [formControl]="registerForm.controls.password" />
                    <button
                      type="button"
                      class="password-toggle"
                      [attr.aria-label]="showPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
                      (click)="togglePassword()">
                      <ng-container [ngTemplateOutlet]="eyeIcon"></ng-container>
                    </button>
                  </div>

                  @if (registerForm.controls.password.hasError('required') && registerForm.controls.password.touched) {
                    <span class="field-error">Bitte gib ein Passwort ein.</span>
                  } @else if ((registerForm.controls.password.hasError('minlength') || registerForm.controls.password.hasError('pattern')) && registerForm.controls.password.touched) {
                    <span class="field-error">Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten.</span>
                  }
                </label>

                <label class="field">
                  <span class="field-label">Passwort bestätigen <span class="required">*</span></span>
                  <div class="password-wrapper">
                    <input
                      class="input"
                      id="passwordConfirmation"
                      name="passwordConfirmation"
                      autocomplete="new-password"
                      maxlength="255"
                      [type]="showPasswordConfirmation() ? 'text' : 'password'"
                      [class.is-invalid]="(registerForm.controls.passwordConfirmation.invalid || registerForm.hasError('passwordMismatch')) && registerForm.controls.passwordConfirmation.touched"
                      [formControl]="registerForm.controls.passwordConfirmation" />
                    <button
                      type="button"
                      class="password-toggle"
                      [attr.aria-label]="showPasswordConfirmation() ? 'Passwort verbergen' : 'Passwort anzeigen'"
                      (click)="togglePasswordConfirmation()">
                      <ng-container [ngTemplateOutlet]="eyeIcon"></ng-container>
                    </button>
                  </div>

                  @if (registerForm.controls.passwordConfirmation.hasError('required') && registerForm.controls.passwordConfirmation.touched) {
                    <span class="field-error">Bitte bestätige dein Passwort.</span>
                  } @else if (registerForm.hasError('passwordMismatch') && registerForm.controls.passwordConfirmation.touched) {
                    <span class="field-error">Die Passwörter stimmen nicht überein.</span>
                  }
                </label>
              </div>

              <div class="hint">Mindestens 8 Zeichen, mit Groß- und Kleinbuchstaben sowie einer Zahl.</div>

              <div class="actions">
                <button type="button" class="btn btn-secondary" (click)="previousStep()">Zurück</button>
                <button type="submit" class="btn btn-primary" [disabled]="isSubmitting()">
                  {{ isSubmitting() ? 'Wird gesendet …' : 'Registrieren' }}
                </button>
              </div>
            </div>
          }
        }

        @if (errorMessage() !== null) {
          <div class="form-error" role="alert">
            {{ errorMessage() }}
          </div>
        }
      </form>

      <div class="auth-links centered">
        <div>Bereits Mitglied? <a [routerLink]="['/login']">Anmelden.</a></div>
      </div>
      <div class="legal-hint">
        Indem du fortfährst, stimmst du unseren
        <a [href]="termsUrl" target="_blank" rel="noopener">Nutzungsbedingungen</a>
        und unserer
        <a [href]="privacyUrl" target="_blank" rel="noopener">Datenschutzerklärung</a>
        zu.
      </div>
    }
  </div>
</section>

<ng-template #eyeIcon>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
</ng-template>
